import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tab, Tabs } from '@material-ui/core';

import { TABS } from '../../const';
import { useStyles } from './useStyles';

export const DatasetTabs = ({ currentTab, onTabChange }) => {
  const styles = useStyles();

  const handleTabChange = (event, tabIndex) => {
    onTabChange(tabIndex);
  };

  return (
    <Tabs
      className={styles.tabs}
      classes={{ indicator: styles.indicator }}
      value={currentTab}
      onChange={handleTabChange}
      indicatorColor="primary"
    >
      <Tab
        className={cx(styles.tab, {
          [styles.selected]: currentTab === TABS.anyword,
        })}
        label="Anyword data sets"
        value={TABS.anyword}
      />

      <Tab
        className={cx(styles.tab, {
          [styles.selected]: currentTab === TABS.custom,
        })}
        label={<div className={styles.customTab}>Your custom models</div>}
        value={TABS.custom}
      />
    </Tabs>
  );
};

DatasetTabs.propTypes = {
  currentTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

DatasetTabs.defaultProps = {};
